import { enhancedApi } from '.'

/**
 * Flipping an in-app notification's read state patches every cached list page
 * ahead of the response so the row dims and the bell badge moves on click. The
 * unread total is adjusted on the `read: false` caches even when the row isn't
 * on the cached page — the bell badge reads its count from a one-row query
 * whose page rarely holds the clicked notification. Rows stay where they are;
 * the generated `invalidatesTags` still refetches, so the patch only has to
 * cover the request's flight.
 */
// eslint-disable-next-line import/prefer-default-export
export const { useMarkInAppNotificationReadMutation } = enhancedApi.enhanceEndpoints({
  endpoints: {
    markInAppNotificationRead: {
      onQueryStarted: async ({ notificationId, markReadRequest }, { dispatch, getState, queryFulfilled }) => {
        const state = getState()
        const cachedArgs = enhancedApi.util.selectCachedArgsForQuery(state, 'listInAppNotifications')
        const cachedRow = cachedArgs
          .flatMap((args) => enhancedApi.endpoints.listInAppNotifications.select(args)(state).data?.data ?? [])
          .find((row) => row.id === notificationId)
        const flipsState = cachedRow !== undefined && cachedRow.read !== markReadRequest.read
        const unreadDelta = markReadRequest.read ? -1 : 1

        const patches = cachedArgs.map((args) =>
          dispatch(
            enhancedApi.util.updateQueryData('listInAppNotifications', args, (draft) => {
              const row = draft.data.find((notification) => notification.id === notificationId)
              if (row) row.read = markReadRequest.read

              const pagination = draft.meta?.pagination
              if (pagination && flipsState && args.read === false) {
                pagination.totalItems = Math.max(pagination.totalItems + unreadDelta, 0)
              }
            })
          )
        )

        try {
          await queryFulfilled
        } catch {
          patches.forEach((patch) => patch.undo())
        }
      }
    }
  }
})
